import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getNewsLocationsRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/news/locations");

  return response.data;
};
